<template>
  <div class="summary">
    <payment-loading-view />
    <div class="left">
      <div class="top">
        <logo-view />
      </div>
      <div class="middle">
        <info-view />
      </div>
      <div class="bottom">
        <order-error-view v-if="this.$store.state.orderErrorVisible" />
      </div>
    </div>
    <div class="right">
      <div class="top">
        <subscription-type-view
          v-if="this.$store.state.subscriptionTypeLoaded"
        />
      </div>
      <div class="middle">
        <hint-view />
      </div>
    </div>
  </div>
</template>

<script>
import InfoView from "@/components/Order/Info.vue";
import LogoView from "@/components/Checkout/Logo.vue";
import SubscriptionTypeView from "@/components/Checkout/SubscriptionType.vue";
import OrderErrorView from "@/components/Order/OrderError.vue";
import HintView from "@/components/Order/Hint.vue";
import PaymentLoadingView from "@/components/Checkout/PaymentLoading.vue";

export default {
  name: "summary-view",
  props: {},
  components: {
    "logo-view": LogoView,
    "info-view": InfoView,
    "hint-view": HintView,
    "subscription-type-view": SubscriptionTypeView,
    "order-error-view": OrderErrorView,
    "payment-loading-view": PaymentLoadingView,
  },
  computed: {},
  methods: {},
  async mounted() {
    if (typeof this.$router.history.current.query.email != "undefined") {
      this.$store.commit("assignPaymentLoading", true);
      await this.$store.dispatch("createSubscriptionOnRedirect");
    }
    await this.$store.dispatch("getSubscription");
    await this.$store.dispatch("getCountries");
    await this.$store.dispatch(
      "getSubscriptionType",
      this.$store.state.subscription.subscription_type_id
    );
    if (this.$store.state.subscription.vat_id != "") {
      this.$store.commit("assignVatCheckSuccessfull", true);
    }
    this.$store.commit("assignSubscriptionTypeLoaded", true);
    this.$store.commit("assignPaymentLoading", false);
  },
};
</script>

<style scoped>
.summary {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
}
.left {
  width: 50%;
  height: 100%;
  display: flex;
  border-right: 1px solid #c7c9c8;
  flex-direction: column;
  padding-right: 60px;
}
.left .top {
  display: flex;
  width: 100%;
  height: 15%;
}
.left .middle {
  display: flex;
  width: 100%;
  height: 55%;
}
.left .bottom {
  display: flex;
  width: 100%;
  height: 20%;
}

.right {
  width: 50%;
  height: 100%;
  display: flex;
  border-left: 1px solid #c7c9c8;
  flex-direction: column;
  padding-left: 60px;
}
.right .top {
  display: flex;
  width: 100%;
  height: 40%;
}
.right .middle {
  display: flex;
  width: 100%;
  height: 35%;
}
.right .bottom {
  display: flex;
  width: 100%;
  height: 15%;
}

@media screen and (max-width: 1420px) {
  .summary {
    flex-direction: column;
  }
  .left {
    margin-bottom: 40px;
  }
  .left,
  .right {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    height: 730px;
    border: none;
  }
}
@media print {
  .right .top {
    height: 60%;
  }
  .left .bottom {
    display: none;
  }
  .left,
  .right {
    width: 100%;
    border: none;
    height: 65%;
    padding: 0;
  }
  .left {
    height: 35%;
  }
  .headline-container,
  .info-complete {
    display: none;
  }
  .summary {
    flex-direction: column;
  }
}
</style>
